<template>
    <div class="ImageList" :class="computedClass">
        <ImageListEntry
            v-for="row in images"
            :key="row.key"
            :image="row.image"
            @moveUp="$emit('moveUp', row.key)"
            @moveDown="$emit('moveDown', row.key)"
            @delete="$emit('delete', row.key)"
        />
    </div>
</template>

<script>
import ImagePreview from '../ImagePreview.vue';
import ImageListEntry from './ImageListEntry.vue';

export default {
    name: 'ImageList',
    components: {
        // ImagePreview,
        ImageListEntry,
    },
    props: {
        images: {
            required: true,
        },
    },
    computed: {
        computedClass() {
            return {};
        },
    },
};
</script>

<style lang="scss" scoped></style>
